import { render, staticRenderFns } from "./RequireUpgradeAccountModal.vue?vue&type=template&id=1bc98310&scoped=true"
import script from "./RequireUpgradeAccountModal.vue?vue&type=script&lang=js"
export * from "./RequireUpgradeAccountModal.vue?vue&type=script&lang=js"
import style0 from "./RequireUpgradeAccountModal.vue?vue&type=style&index=0&id=1bc98310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc98310",
  null
  
)

export default component.exports